module.exports = __webpack_public_path__ + "files/8542fb16912775d6b5ec5f098a08ffdd.png";